import { Component, Input, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from 'src/app/services/loader.service';
import { CheckoutStore } from 'src/app/stores/checkout.store';
import { currencyCode, imageUrl } from 'src/environments/environment';

@Component({
  selector: 'app-order-review-product',
  templateUrl: './order-review-product.component.html',
  styleUrls: ['./order-review-product.component.scss'],
})
export class OrderReviewProductComponent implements OnInit {
  @Input() cartIndex: number;
  imageUrl = imageUrl;
  currencyCode = currencyCode;
  productVariation: number
  constructor(
    public checkoutStore: CheckoutStore,
    private loaderService: LoaderService,
    private translateService: TranslateService,
    public platform:Platform
  ) { }

  ngOnInit() { }

  selectItem() {
    setTimeout(() => {
      this.checkoutStore.cartData.cart[this.cartIndex].selectAll =
        this.checkoutStore.cartData.cart[this.cartIndex].items.find(
          (item) => !item.selected
        )
          ? false
          : true;
      this.checkoutStore.cartData.selectAll =
        this.checkoutStore.cartData.cart.find((cart) => !cart.selectAll)
          ? false
          : true;
      this.setCheckout();
    }, 100);
  }

  async setQty(value: number, index: number) {
    this.checkoutStore.cartData.cart[this.cartIndex].items[index].qty =
      this.checkoutStore.cartData.cart[this.cartIndex].items[index].qty == 1 &&
        value == -1
        ? this.checkoutStore.cartData.cart[this.cartIndex].items[index].qty
        : this.checkoutStore.cartData.cart[this.cartIndex].items[index].qty +
        value;
    var shopTotal = 0;
    var shopSaving = 0;
    this.checkoutStore.cartData.cart[this.cartIndex].items.forEach((item) => {
      shopTotal = shopTotal + item.qty * item.price;
      shopSaving = shopSaving + item.qty * item.actual_price - shopTotal;
    });
    this.checkoutStore.cartData.cart[this.cartIndex].item_total = shopTotal;
    this.checkoutStore.cartData.cart[this.cartIndex].total_saving =
      shopSaving > 0 ? shopSaving : 0;
    this.setCheckout();

    this.loaderService.showLoading();
    var optionIndex = this.checkoutStore.cartData.cart[this.cartIndex].items[index].options.findIndex(x => x.id === this.checkoutStore.cartData.cart[this.cartIndex].items[index].option_data)
    try {
      var resp = await this.checkoutStore.postCartAddUpdate({
        cart_id: Number(localStorage.getItem('cart_id')),
        product_id: this.checkoutStore.cartData.cart[this.cartIndex].items[index].product_id,
        qty: this.checkoutStore.cartData.cart[this.cartIndex].items[index].qty,
        product_variation: this.checkoutStore.cartData.cart[this.cartIndex].items[index].options.length > 0 ?
          [{
            id: this.checkoutStore.cartData.cart[this.cartIndex].items[index].options[optionIndex].product_variation_id,
            variation_fields: [{ id: this.checkoutStore.cartData.cart[this.cartIndex].items[index].options[optionIndex].id }]
          }] :
          [],
      });
      this.checkoutStore.cartData = resp.data;
      this.loaderService.dismissLoading();
    } catch (error) {
      this.loaderService.dismissLoading();
      this.checkoutStore.cartData.cart[this.cartIndex].items[index].qty =
        this.checkoutStore.cartData.cart[this.cartIndex].items[index].qty - 1;
      this.loaderService.presentToast(error?.error?.data ? error?.error?.data : this.translateService.instant('PRODUCT_BAG.OUT_OF_STOCK'),
        'middle',
        'danger',
        2000
      );
    }
  }

  async setCheckout() {
    this.checkoutStore.cartData.total = 0;
    this.checkoutStore.cartData.total_saving = 0;
    this.checkoutStore.cartData.cart.forEach((cart, i) => {
      var items = cart.items.filter((item) => item.selected);
      var itemTotal = 0;
      var itemSaving = 0;
      if (items.length > 0) {
        items.forEach((item, index) => {
          itemTotal = itemTotal + item.price * item.qty;
          itemSaving = itemSaving + item.actual_price * item.qty;
        });
        this.checkoutStore.cartData.total = this.checkoutStore.cartData.total + itemTotal;
        this.checkoutStore.cartData.total_saving = this.checkoutStore.cartData.total_saving + itemSaving;
      } else {
        cart.items.forEach((cartUpdate) => {
          itemTotal = itemTotal + cartUpdate.price * cartUpdate.qty;
          itemSaving = itemSaving + cartUpdate.actual_price * cartUpdate.qty;
        })
      }
      this.checkoutStore.cartData.cart[i].item_total = itemTotal
      this.checkoutStore.cartData.cart[i].total_saving = itemSaving - itemTotal

    });
  }

  // `Are you sure you want to delete this item?`

  async delteItem(value) {
    var response = await this.loaderService.confirmPopup(this.translateService.instant('PRODUCT_BAG.DELETE_CART_TEXT'));
    if (response) {
      this.loaderService.showLoading();
      try {
        await this.checkoutStore.removeCartItem({
          seller_id: null,
          product_id: value.product_id,
          options: value?.options?.length > 0 ? value.options[0].id : null
        });
        this.loaderService.dismissLoading();
      } catch (error) {
        this.loaderService.dismissLoading();
        this.loaderService.presentToast(
          error.error.data
            ? error.error.data
            : this.translateService.instant('RATE_ORDER.SOMETHING_WRONG'),
          'middle',
          'danger',
          2000
        );
      }

    }
  }
}
